import * as React from "react";
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {HOME_ROUTES, PRICING_ROUTES} from "@constants"
import HomePage from "./Page";


export const HomeRoutes = {
    path: "/",
    title: HOME_ROUTES.TITLE,
    icon: 'home',
    element: <AppLayout />,
    hideInHome: true,
    children: [
        { element: <Navigate to={HOME_ROUTES.HOME_URL} replace />, index: true },
        {path: HOME_ROUTES.HOME_URL, element: <HomePage />}
    ]
}